
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
export default {
  components: { VueSlickCarousel },
  data() {
    return {
      loader: false,
      loaded: false,
      activeSlideIndex: 0,
      autoplaySuccess: true,
      activeTooltipIndex: null,

      options: [
        {
          name: "video",
          label: "Oznacite kvadratic ako trebate dodat video na ovaj slide",
          type: "checkbox",
        },
      ],
      socialOptions: [
        {
          name: "logo",
          label: "Logo",
          type: "image",
        },
        {
          name: "link",
          label: "Poveznica",
          type: "link",
        },
      ],
      settings: {
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 2000,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
      },
    };
  },

  mounted() {
    this.loaded = true;

    setTimeout(() => {
      this.setVideoAttributes();
    }, 300);
  },
  methods: {
    setActiveIndex(oldIndex, newIndex) {
      // this.loader = true;
      // this.activeSlideIndex = newIndex;
      // this.setVideoAttributes();
      // setTimeout(() => {
      //   this.loader = false;
      // }, 500);
    },

    setVideoAttributes() {
      const attributes = {
        playsinline: "",
        preload: "auto",
        autoplay: "",
        muted: "",
        loop: "",
      };

      const section = document.getElementsByClassName("section-hero-slider");

      if (section && section[0]) {
        setTimeout(() => {
          const videos = section[0].getElementsByTagName("video");

          if (videos && videos.length) {
            videos.forEach((video) => {
              video.addEventListener("suspend", () => {
                video.play();
              });
              video.muted = true;
              video.playsinline = true;
              video.load();
              video.play();
              video.removeAttribute("controls");
              Object.keys(attributes).forEach((attr) => {
                video.setAttribute(attr, attributes[attr]);
              });
              const promise = video.play();
              if (promise !== undefined) {
                promise
                  .then(() => {
                    this.autoplaySuccess = true;
                  })
                  .catch((error) => {
                    this.autoplaySuccess = false;
                  });
              }
            });
          }
        }, 300);
      }
    },
  },
};
